var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00146 12.9603V15.0003C2.00146 20.0003 4.00146 22.0003 9.00146 22.0003H15.0015C20.0015 22.0003 22.0015 20.0003 22.0015 15.0003V9.00034C22.0015 4.00034 20.0015 2.00034 15.0015 2.00034H9.00146C4.00146 2.00034 2.00146 4.00034 2.00146 9.00034",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxEmpty);
export default __webpack_public_path__ + "static/media/CheckBox_empty.131cd65933aca78619dd84bc866806b9.svg";
export { ForwardRef as ReactComponent };